import { useEffect, useState } from 'react';

import { WITHDRAWAL_ENABLED } from '@/lib/const';
import { captureError } from '@/lib/errors';
import type { ReturnReason } from '@/views/OrderReturnView/orderReturnTypes';

export function useGuestReturnReasons(isGuestMode: boolean): ReturnReason[] {
  const [guestReasons, setGuestReasons] = useState<ReturnReason[]>([]);

  useEffect(() => {
    async function loadGuestReasons() {
      if (!WITHDRAWAL_ENABLED || !isGuestMode) {
        setGuestReasons([]);
        return;
      }

      try {
        const response = await fetch('/api/withdrawal/reasons');
        if (!response.ok) {
          setGuestReasons([]);
          return;
        }

        const payload = (await response.json()) as {
          data?: { returnReasons?: ReturnReason[] };
        };
        setGuestReasons(payload.data?.returnReasons ?? []);
      } catch (error) {
        captureError(error as Error, {
          extra: { route: 'GET /api/withdrawal/reasons (guest return flow)' },
        });
        setGuestReasons([]);
      }
    }

    void loadGuestReasons();
  }, [isGuestMode]);

  return guestReasons;
}
